import { useState, useRef, useEffect } from "react";
import { avironixTestApi, checkMauiAdmin, checkMauiUser, mauiUserLike, mauiUserCreation, mauiUserUrlUpdation, sessionStart, sessionEnd, getThread } from "../services/apiService";
import { v4 as uuidv4 } from 'uuid';
//import VoiceRecorder, { VoiceRecorderHandle } from "../components/VoiceRecorder";
import AvironixVoiceRecorder, { AvironixVoiceRecorderHandle } from "../components/AvironixVoiceRecorder";
import send from "../assects/img/Send.png" 
import gray_send from "../assects/img/Gray_Send.png"
import xoroLogo from "../assects/img/avironix_logo.png";
import { useSearchParams } from "react-router-dom";
import CryptoJS from 'crypto-js';

interface Message {
  sender: "user" | "bot" | "loading" | "newSession";
  text: string;
}

    interface SidebarLayoutProps {
        user_id: number;
    }
    
    const AvironixViewLogs: React.FC<SidebarLayoutProps> = ({user_id }) => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [audioLoading, setAudioLoading] = useState(false);
  const [wholeLoading, setWholeLoading] = useState(false);
  const chatEndRef = useRef<HTMLDivElement>(null);
  const [current_user_chat_code, setCurrent_user_chat_code] = useState("");
  const [showShareForm, setShowShareForm] = useState(false);
  const [blockUser,setBlockUser] = useState(false)
  const [outerCheckLoading,setOuterCheckLoading] = useState(false)
  const [userType,setUserType] = useState("")
  const [adminAccountId,setAdminAccountId] = useState(0)
  const [userID,setUserID] = useState(0)
  const [guestAcc,setGuestAcc] = useState(false)
  const [likeLoading,setLikeLoading] = useState(false)
  const [chatLiked,setChatLiked] = useState(false)
  const [shareFormData, setShareFormData] = useState({ username: "", mobile: "", interested_in: ""});
  const [createUserUrl,setCreatedUserUrl] = useState("")
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [thread,setThread] = useState([])

  useEffect(()=>{
    let threadArr: Message[] = []

    thread.forEach((list:any,index)=>{
      // const preIndexValue: Message  = threadArr[threadArr.length-1]
      if(!list.content[0].text.value.includes("Current User Details:")){
        // if(list.role === "user"){
        //   threadArr = threadArr.filter((_, i) => i !== threadArr.length-1)
        // }
        if(list.content[0].text.value.includes("SUBS123")){
          const obj: Message = { 
            sender: "newSession", 
            text: "",
          }
          threadArr.push(obj);
        }
        else{
          const obj: Message = { 
            sender: list.role === "assistant" ? "bot" : "user", 
            text: list.role === "assistant" ? list.content[0].text.value : list.content[0].text.value.replace("Device: DESKTOP.User Query:", "").replace("Device: MOBILE.User Query:", ""),
          }
          threadArr.push(obj)
        }
        // if(list.role === "user"){
        //   threadArr.push(preIndexValue)
        // }
      }
    })
    setMessages(threadArr);
  },[thread])

  const voiceRecorderRef = useRef<AvironixVoiceRecorderHandle>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const getCurrentTimestamp = () => {
    return new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
  };

  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const jsonCheck = (str:string) => {
    try{
      JSON.parse(str)
      return true
    }
    catch (err){
      return false
    }
  };

  const encryptString = (string: any, secretKey: any) => {
      const encryptedString2 = CryptoJS.AES.encrypt(string, secretKey).toString();
      return encodeURIComponent(encryptedString2);
  };

  const decryptString = (encodedCipher: string, secretKey: string) => {
    const cipherB64 = decodeURIComponent(encodedCipher);      
    const bytes = CryptoJS.AES.decrypt(cipherB64, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);                
  };

  const admin = searchParams.get("admin") ?? searchParams.get("Admin") ?? "";  
  const user = searchParams.get("user") ?? searchParams.get("User") ?? "";

  async function checkMauiAdminApi(){
    return await checkMauiAdmin(Number(decryptString(admin,'xoro')))
  }

  async function checkMauiUserApi(){
    return await checkMauiUser(Number(decryptString(user,'xoro')))
  }

  useEffect(() => {
    setWholeLoading(true);

    getThread(user_id).then((res)=> {
            setThread(res.data.thread)
          }
        )

        setWholeLoading(false);
  }, []);

  async function userLike(){
    setLikeLoading(true)
    await mauiUserLike(userID)
    .then(res => {
      res.data.status === "success" ? setChatLiked(res.data.like_status) : alert("Error while liking")
    })
    .catch(err => {
      console.log(err)
    })
    .finally(()=>{
      setLikeLoading(false)
    })
  }

  const handleBotReply = async (user_id1:string,user_type1: string,userInput: string, cc?: any, audioBlob?: Blob) => {
    try {
      setLoading(true);

      const formData = new FormData();
      let audio = false;

      voiceRecorderRef.current?.stopRecording();
      const deviceContext = window.innerWidth <= 768 ? 'MOBILE' : 'DESKTOP';
      formData.append('device', deviceContext);
      if (audioBlob) {
        formData.append('audio', audioBlob, 'voice.webm');
        formData.append('userQuery',  "");
        setMessages(prev => [...prev, { 
          sender: "user", 
          text: "🎤 (voice message sent)",
          timestamp: getCurrentTimestamp()
        }]);
        setMessages(prev => [...prev, { 
          sender: "loading", 
          text: "🤖 Getting response...",
          timestamp: getCurrentTimestamp()
        }]);
        audio = true;
      } else {
        formData.append('userQuery', userInput);
        if(userInput !== "SUBS123"){
            const userMessage: Message = { 
              sender: "user", 
              text: input,
            };
            setMessages((prev) => [...prev, userMessage]);
        }
      
        
        setMessages((prev) => [...prev, { 
          sender: "loading", 
          text: "🤖 Getting response...",
          timestamp: getCurrentTimestamp()
        }]);
      }

      formData.append('current_user_chat_code', current_user_chat_code || cc);
      formData.append('user_type', `${user_type1}`);
      formData.append('user_id', `${user_id1}` || "");

      const response = await avironixTestApi(formData);
      const userAudioText = response.transcribed_text;
      //const botReply = response.reply || "No response";
      let botReply: string;
      try {
        const jsonResponse = JSON.parse(response.reply);
        
        // 🔧 SUPPORT BOTH OLD AND NEW FORMATS
        const isSummary = jsonResponse.summery_status === true || jsonResponse.is_summary === true;
        const summaryData = jsonResponse.summery || jsonResponse.summary_data;
        const responseContent = jsonResponse.response || jsonResponse.reply;
        console.log(jsonResponse)
        
        if (isSummary) {
          botReply = responseContent;
        } else {
          botReply = responseContent || "No response";
        }
      } catch (parseError) {
        //console.log("JSON Parse failed:", parseError);
        botReply = response.reply || "No response";
      }

      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => onTimeout(Number(user_id1)), 10 * 60 * 1000);

      if (audio) {
        setMessages((prev: any) => {
          const updated = prev.map((msg: any, index: number) => {
            if (index === prev.length - 2) {
              return { ...msg, text: `🎤 (voice message sent) - ${userAudioText}` };
            } else {
              return msg;
            }
          });
          return [...updated];
        });
      }

      setMessages((prev) => {
        const filtered = prev.filter(msg => msg.text !== "🤖 Getting response...");
        return [...filtered, { 
          sender: "bot", 
          text: botReply,
          timestamp: getCurrentTimestamp()
        }];
      });

      if (response.role !== "") {
        localStorage.setItem('userBotRole', response.role);
      }
    } catch (error) {
      setMessages((prev) => [
        ...prev,
        { 
          sender: "bot", 
          text: "Sorry, something went wrong.",
          timestamp: getCurrentTimestamp()
        },
      ]);
      setMessages((prev) => {
        const filtered = prev.filter(msg => msg.text !== "🤖 Getting response...");
        return [...filtered];
      });
    } finally {
      setLoading(false);
    }
  };

  const onTimeout = (user_id23:number) => {
    // sessionEnd(user_id23,"bt")
  };


  const sendMessage = async (audioBlob?: Blob) => {
    const currentInput = input;
    setInput("");
    await handleBotReply(userID.toString(),userType,currentInput, "" , audioBlob);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") sendMessage();
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleShareSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await mauiUserCreation(adminAccountId,shareFormData.username,shareFormData.mobile,shareFormData.interested_in)
    .then(res => {
        let encodedString = encryptString(`${res.data.user_id}`,'xoro') 
        let encodedString2 = encryptString(`${adminAccountId}`,'xoro')
        let url = `https://stagingadmin.xorostory.com/Avironix?user=${encodedString}&account${encodedString2}`
        setCreatedUserUrl(url)
        mauiUserUrlUpdation(res.data.user_id,url)
    })
    // setShowShareForm(false);
    // setShareFormData({ username: "", mobile: "", interested_in: ""});
  };

  const handleShareFormChange = (field: string, value: string) => {
    setShareFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <>
      {
        outerCheckLoading || blockUser ? 
          <div className="w-full h-[100vh] flex items-center justify-center">
            {wholeLoading ? (
              <div className="fixed inset-0 bg-black/20 backdrop-blur-sm flex items-center justify-center z-50 px-4">
                <div className="bg-white/95 backdrop-blur-xl rounded-2xl border border-gray-200/50 shadow-2xl p-6 flex flex-col items-center space-y-4 max-w-sm w-full">
                  <div className="flex space-x-2">
                    <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
                    <div className="w-3 h-3 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                    <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
                  </div>
                  <p className="text-gray-700 font-medium text-center text-sm sm:text-base">Loading your user experience</p>
                </div>
              </div>
            ) : <p>{blockUser && "Unauthorised User Found"}</p>}
          </div> 
        :
        <div className="w-full h-[600px] flex flex-col bg-gradient-to-br from-slate-50 via-white to-blue-50/30">
      
      {/* Header - Mobile Optimized */}
      

      {/* Chat Messages */}
      <div className="flex-1 overflow-y-auto px-1 sm:px-2 py-4 sm:py-6">
        <div className="w-full sm:w-[90%] lg:w-[90%] mx-auto space-y-4 sm:space-y-6">
          {messages.map((msg, index) => (
            msg.sender === "newSession"
            ?
            <div className="w-full">
             { index != 0 && <div>
                <div className="h-[1px] border border-gray-400"></div>
                <p className="text-center"> --- New Session ---</p>
              </div> }
            </div>
            :
            <div
              key={index}
              className={`flex items-start ${
                msg.sender === "user" 
                ? "flex-row-reverse"
                : "space-x-2 sm:space-x-3"
              }`}
            >
              {/* Avatar */}
              <div className={`flex-shrink-0 w-7 h-7 sm:w-9 sm:h-9 flex items-center justify-center ${
                msg.sender === "user" 
                  ? "rounded-full bg-gradient-to-br from-blue-500 to-purple-600 shadow-md ml-3 sm:ml-4" 
                  : ""
              }`}>
                {msg.sender === "user" ? (
                  <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                ) : (
                  <img 
                    src={xoroLogo} 
                    alt="XORO Logo" 
                    className="w-5 h-5 sm:w-6 sm:h-6 object-cover rounded-full"
                  />
                )}
              </div>

              <div className={`max-w-[85%] sm:max-w-[75%] ${msg.sender === "user" ? "items-end" : "items-start"} flex flex-col`}>
                <div className={`px-3 sm:px-4 py-2 sm:py-3 rounded-2xl shadow-sm border text-sm sm:text-base ${
                  msg.sender === "user"
                    ? "bg-gradient-to-br from-blue-500 to-purple-600 text-white border-transparent"
                    : msg.sender === "loading"
                    ? "bg-white/90 backdrop-blur-sm border-gray-200/50 text-gray-600"
                    : "bg-white/90 backdrop-blur-sm border-gray-200/50 text-gray-800"
                } ${msg.sender !== "user" ? "rounded-tl-md" : "rounded-tr-md"}`}>
                  
                  {msg.text === "🤖 Getting response..." ? (
                    <div className="flex items-center space-x-2">
                      <div className="flex space-x-1">
                        <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></div>
                        <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
                        <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
                      </div>
                      <span className="text-xs sm:text-sm">Getting response...</span>
                    </div>
                  ) : (
                    <div dangerouslySetInnerHTML={{
                      __html: msg.text === "🤖 Getting response..."
                        ? `<div class="flex items-center justify-center">
                            <div class="flex space-x-1">
                              <div class="h-2 w-2 bg-gray-600 rounded-full animate-bounce" style="animation-delay: 0s;"></div>
                              <div class="h-2 w-2 bg-gray-600 rounded-full animate-bounce" style="animation-delay: 0.1s;"></div>
                              <div class="h-2 w-2 bg-gray-600 rounded-full animate-bounce" style="animation-delay: 0.2s;"></div>
                            </div>
                          </div>`
                        : (jsonCheck(msg.text) ? JSON.parse(msg.text).reply : msg.text) ,
                    }} />
                  )}
                </div>
                
                {/* Timestamp */}
                
              </div>
            </div>
          ))}
          <div ref={chatEndRef} />
        </div>
      </div>

      {/* Suggestion Buttons  */}
      {/* {messages.length <= 1 && (
        <div className="px-3 sm:px-4 pb-3 sm:pb-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white/70 backdrop-blur-sm rounded-2xl border border-gray-200/50 p-4 sm:p-5 shadow-lg">
              <p className="text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4 text-center font-medium">Explore our other products:</p>
              <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-2 sm:gap-3">
                <button 
                  onClick={() => setInput("Aviguard")}
                  className="px-4 sm:px-5 py-2 sm:py-2.5 bg-gradient-to-r from-blue-50 to-purple-50 hover:from-blue-100 hover:to-purple-100 rounded-full text-xs sm:text-sm text-gray-700 border border-gray-200/50 hover:border-gray-300 transition-all duration-300 hover:shadow-md hover:scale-105 font-medium"
                >
                   Aviguard
                </button>
                <button 
                  onClick={() => setInput("AviCargo 20")}
                  className="px-4 sm:px-5 py-2 sm:py-2.5 bg-gradient-to-r from-emerald-50 to-teal-50 hover:from-emerald-100 hover:to-teal-100 rounded-full text-xs sm:text-sm text-gray-700 border border-gray-200/50 hover:border-gray-300 transition-all duration-300 hover:shadow-md hover:scale-105 font-medium"
                >
                   AviCargo 20
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {/* Input Area  */}
      
      {/* Share Form Modal */}
      {showShareForm && (
        <div className="fixed inset-0 bg-black/20 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div className="bg-white/95 backdrop-blur-xl rounded-2xl border border-gray-200/50 shadow-2xl p-6 max-w-sm w-full">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center">
                <h3 className="text-lg font-bold text-gray-800 me-3">{guestAcc ? "Guest" : "Create User"}</h3>
                {
                  guestAcc ?
                    <button
                      type="button"
                      onClick={()=>setGuestAcc(false)}
                      className="flex-1 px-3 py-2 bg-gradient-to-r from-blue-400 to-purple-500 hover:from-blue-500 hover:to-purple-600 text-white rounded-xl transition-all hover:shadow-lg text-sm font-medium"
                    >
                      Create User
                    </button>
                  :
                    <button
                      type="button"
                      onClick={()=>setGuestAcc(true)}
                      className="flex-1 px-3 py-2 bg-gradient-to-r from-blue-400 to-purple-500 hover:from-blue-500 hover:to-purple-600 text-white rounded-xl transition-all hover:shadow-lg text-sm font-medium"
                    >
                      Guest 
                    </button>
                }
              </div>
              <button 
                onClick={() => {
                  setShareFormData({ username: "", mobile: "", interested_in: ""});
                  setCreatedUserUrl("")
                  setShowShareForm(false)
                }}
                className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            {!guestAcc ?
            <form onSubmit={handleShareSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Username</label>
                <input
                  type="text"
                  value={shareFormData.username}
                  onChange={(e) => handleShareFormChange("username", e.target.value)}
                  placeholder="Enter username"
                  className="w-full px-4 py-3 bg-white/90 border border-gray-200/50 rounded-xl focus:outline-none focus:border-blue-300/50 text-gray-800 placeholder-gray-500 text-sm"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
                <input
                  type="tel"
                  value={shareFormData.mobile}
                  onChange={(e) => handleShareFormChange("mobile", e.target.value)}
                  placeholder="Enter mobile number"
                  className="w-full px-4 py-3 bg-white/90 border border-gray-200/50 rounded-xl focus:outline-none focus:border-blue-300/50 text-gray-800 placeholder-gray-500 text-sm"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">More Info</label>
                <input
                  type="text"
                  value={shareFormData.interested_in}
                  onChange={(e) => handleShareFormChange("interested_in", e.target.value)}
                  placeholder="Enter more details(Interested part)"
                  className="w-full px-4 py-3 bg-white/90 border border-gray-200/50 rounded-xl focus:outline-none focus:border-blue-300/50 text-gray-800 placeholder-gray-500 text-sm"
                  required
                />
              </div>
              
              <div className="flex space-x-3 pt-2">
                <button
                  type="button"
                  onClick={() =>{
                    setShareFormData({ username: "", mobile: "", interested_in: ""});
                    setCreatedUserUrl("")
                    setShowShareForm(false)
                  }}
                  className="flex-1 px-4 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl transition-colors text-sm font-medium"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-1 px-4 py-3 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white rounded-xl transition-all hover:shadow-lg text-sm font-medium"
                >
                  Create
                </button>
              </div>

              {createUserUrl && (
                <div className="pt-3 space-y-2">
                  <p className="font-medium">Copy or share URL:</p>
                  <button
                    type="button"
                    onClick={async () => {
                      try {
                        await navigator.clipboard.writeText(createUserUrl);
                        alert("Link copied to clipboard. Paste it into any app to share.");
                      } catch {
                        const wa = `https://wa.me/?text=${encodeURIComponent(createUserUrl)}`;
                        window.open(wa, "_blank");
                      }
                    }}
                    className="w-full px-4 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl transition-all hover:shadow-lg text-sm font-medium"
                  >
                    Copy URL
                  </button>

                  <button
                    type="button"
                    onClick={async () => {
                      const title = `Avironix Assistant — Invite: \nHey ${shareFormData.username}! Here is your link:`;
                      const url   = createUserUrl;

                      if (navigator.share) {
                        try {
                          await navigator.share({ title, url });
                          return;
                        } catch (err) {
                        }
                      }
                    }}
                    className="w-full px-4 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl transition-all hover:shadow-lg text-sm font-medium"
                  >
                    Share
                  </button>
                </div>
              )}
            </form>
            :
            <div>
              <button
                type="button"
                onClick={async () => {
                  try {
                    await navigator.clipboard.writeText("https://stagingadmin.xorostory.com/Avironix?user=U2FsdGVkX1%2BdyBpOK9vo2FjPu72lXC2blpPv4txYguk%3D");
                    alert("Link copied to clipboard. Paste it into any app to share.");
                  } catch {
                    const wa = `https://wa.me/?text=${encodeURIComponent(createUserUrl)}`;
                    window.open(wa, "_blank");
                  }
                }}
                className="w-full px-4 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl transition-all hover:shadow-lg text-sm font-medium"
              >
                Copy URL
              </button>
              <button
                type="button"
                onClick={async () => {
                  const title = `Avironix Assistant — Invite: \nHey! Here is your link:`;
                  const url   = "https://stagingadmin.xorostory.com/Avironix?user=U2FsdGVkX1%2BdyBpOK9vo2FjPu72lXC2blpPv4txYguk%3D";

                  if (navigator.share) {
                    try {
                      await navigator.share({ title, url });
                      return;
                    } catch (err) {
                    }
                  }
                }}
                className="w-full px-4 py-3 mt-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl transition-all hover:shadow-lg text-sm font-medium"
              >
                Share
              </button>
            </div>
            }
          </div>
        </div>
      )}

      {/* Loading Overlay */}
      {wholeLoading && (
        <div className="fixed inset-0 bg-black/20 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div className="bg-white/95 backdrop-blur-xl rounded-2xl border border-gray-200/50 shadow-2xl p-6 flex flex-col items-center space-y-4 max-w-sm w-full">
            <div className="flex space-x-2">
              <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
              <div className="w-3 h-3 bg-purple-500 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
              <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
            </div>
            <p className="text-gray-700 font-medium text-center text-sm sm:text-base">Preparing your user experience</p>
          </div>
        </div>
      )}
    </div>
      }
    </>
  );
}

export default AvironixViewLogs;